<template>
    <div class='user' @click="close()" @touchmove.prevent>
        <div class="userInfo">
            <div class="box">
                <div class="renwu">
                    <div class="pic">
                        <img :src="userInfo.avatar" alt="">
                    </div>
                    <div class="p">{{userInfo.nickName}}</div>
                </div>
                <div class="phone">
                    <div class="box-l">
                        <img src="@/assets/img/bd.png" alt="">
                        <div class="p">绑定手机号</div>
                    </div>
                    <div class="box-r">
                        {{userInfo.phone}}
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {

        }
    },
     computed: {
        ...mapGetters({ userInfo: "getUser" })
    },
    created() {

    },
    methods: {
       close() {
            this.$parent.userShow();
        },
    }
}
</script>

<style lang='less' scoped>
.user {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: flex-end;
    .userInfo {
        width: 100%;
        height: 314px;
        overflow: hidden;
        background: #FFFFFF;
        .box {
            margin-top: 49px;
            .renwu {
                display: flex;
                height: 80px;
                align-items: center;
                .pic{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    img{
                        width: 60px;
                    }
                }
                .p {
                    font-size: 30px;
                    padding-left: 25px;
                }
            }
            .phone {
                margin-top: 46px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .box-l {
                    display: flex;
                    align-items: center;
                    img {
                        width: auto;
                        height: 29px;
                    }
                    .p {
                        font-size: 28px;
                        color: #666666;
                        padding-left: 10px;
                    }
                }
                .box-r {
                    font-size: 28px;
                    color: #333333;
                }
            }
        }
    }
}
</style>
